import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import ProductListResults from './ProductListResults';
import Pagination from './Pagination';
import DashboardSection from './DashboardSection';
import PageSizeSelect from './PageSizeSelect';
import ResultCount from './ResultCount';
import SortSelect from './SortSelect';
import DashboardToggles from './DashboardToggles';
import FilterSection from './FilterSection';
import ProductListGrid from './ProductListGrid';

function updateUrlParams(parameterArray) {
    const url = new URL(window.location);

    parameterArray.map(parameter => {
        url.searchParams.set(parameter.name, parameter.value);
    });

    window.history.pushState({}, "", url.href);
}

function setDefaultCurrentPage(shouldParseUrlParams) {
    let currentPage = 1;
    const url = new URL(window.location);

    if (shouldParseUrlParams) {
        currentPage = parseInt(url.searchParams.get('tabpage'), 10);
    } else if (url.searchParams.has("CurrentPage")) {
        currentPage = JSON.parse(url.searchParams.get("CurrentPage"));
    }

    return currentPage;
}

function setDefaultAppliedFilters() {
    let appliedFilters = [];
    const url = new URL(window.location);

    if (url.searchParams.has("filter")) {
        appliedFilters = url.searchParams.getAll("filter").map((filter) => {
            const id = filter.split("-filtertext-")[0];
            const text = filter.split("-filtertext-")[1];
            return { id, text }
        });
    }

    return appliedFilters;
}

function setDefaultSortType() {
    let sort = "1";
    const url = new URL(window.location);

    if (url.searchParams.has("sortType")) {
        sort = JSON.parse(url.searchParams.get("sortType"));
    }

    return sort;
}

function setDefaultPageSize(defaultItemsPerPage) {
    let pageSize = defaultItemsPerPage || 0;
    const url = new URL(window.location);

    if (url.searchParams.has("PageSize")) {
        pageSize = JSON.parse(url.searchParams.get("PageSize"));
    }

    return pageSize;
}

function setDefaultSearchQuery(shouldParseUrlParams) {
    let query = '';
    const url = new URL(window.location);

    if (shouldParseUrlParams) {
        query = url.searchParams.get('q');
    }

    return query;
}

export default function ProductListApp(props) {

    const { apiUrl,
        addToCardApi,
        categoryUrlSegment,
        languageCode,
        itemListName,
        viewCartLabel,
        viewCartUrl,
        filterLabel,
        clearAllFiltersLabel,
        filterMobileLabel,
        filterMobileCloseLabel,
        sortLabel,
        sortMobileLabel,
        sortMobileCloseLabel,
        viewLabel,
        viewMobileLabel,
        viewMobileCloseLabel,
        defaultItemsPerPage,
        productCountLabel,
        successAddToCart,
        failureAddToCart,
        addtoCartLabel,
        shouldParseUrlParams,
        pageUrl    } = props;

    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [pageSize, setPageSize] = useState(setDefaultPageSize(defaultItemsPerPage));
    const [pageSizeOptions, setPageSizeOptions] = useState([]);
    const [sortType, setSortType] = useState(setDefaultSortType());
    const [sortOptions, setSortOptions] = useState([]);
    const [filters, setFilters] = useState([]);
    const [appliedFilters, setAppliedFilters] = useState(setDefaultAppliedFilters());
    const [activePageId, setActivePageId] = useState(setDefaultCurrentPage(shouldParseUrlParams));
    const [totalPageCount, setTotalPageCount] = useState(1);
    const [totalItemCount, setTotalItemCount] = useState(0);
    const [displayResults, setDisplayResults] = useState([]);
    const [searchQuery, setSearchQuery] = useState(setDefaultSearchQuery(shouldParseUrlParams));
    const [firstLoad, setFirstLoad] = useState(true);
    const [activeDashboardCollapse, setActiveDashboardCollapse] = useState(null);

    const getProductListApiParams = function () {
        return {
            AttributeFilters: appliedFilters.map(x => x.id),
            CategoryUrlSegment: categoryUrlSegment,
            LanguageCode: languageCode,
            Page: activePageId,
            PageSize: pageSize,
            Sort: sortType,
            SearchQuery: searchQuery
        };
    }

    const getProductPrice = (product) => {
        if (product.IsStyleProductParent && product.ProductGroupMSRP > 0)
            return product.ProductGroupMSRP;
        if (product.IsPart && product.Pricing.RegularPrice > 0)
            return product.Pricing.RegularPrice;
        if (!product.IsStyleProductParent && !product.IsPart && product.modelMSRP > 0)
            return modelMSRP;
        return null;
    }

    const fetchProducts = (params) => {

        params = params || getProductListApiParams();

        //only call api if the search query is not empty
        if (params.SearchQuery == null) {
            setIsLoading(false);
            setHasError(false);
            return;
        };

        axios.post(apiUrl, params)
            .then((res) => {
                const {
                    data: {
                        Products,
                        AttributeTypeFacets,
                        Pagination
                    }
                } = res

                if (Products == null) {
                    if (params.AttributeFilters !== null && params.AttributeFilters.length > 0) {
                       window.location.replace(pageUrl);
                   } else {
                        window.location.replace(res.data.RedirectOnErrorUrl);
                  }
                    console.log(res.data.RedirectOnErrorUrl);
                    console.log(true);
                }


                setFilters(AttributeTypeFacets);
                setAppliedFilters(AttributeTypeFacets.map(typeFacet => typeFacet.AttributeValueFacets).flat()
                    .filter(valueFacet => valueFacet.Selected)
                    .map(valueFacet => { return { id: valueFacet.AttributeValueId, text: valueFacet.ValueDisplay } }));
                setActivePageId(Pagination.Page);
                setTotalPageCount(Pagination.NumberOfPages);
                setSortType(Pagination.SortType);
                setSortOptions(Pagination.SortOptions);
                setPageSize(Pagination.PageSize);
                setPageSizeOptions(Pagination.PageSizeOptions);
                setDisplayResults(Products);
                setTotalItemCount(Pagination.TotalItemCount);
                setIsLoading(false);
                setHasError(false);
                setActiveDashboardCollapse(null);
                var GA_itemlist = [];
                Products.forEach((element, index) => {
                    let curr_item = {
                        item_name: element.ShortDescription,
                        item_id: element.Sku,
                        price: getProductPrice(element),
                        currency: element.currencyCode,
                        item_list_name: itemListName,
                        index: index,
                        quantity: 1
                    };
                    GA_itemlist.push(curr_item);
                });
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    event: "view_item_list",
                    ecommerce: {
                        items: GA_itemlist
                    }
                });

            }).catch((error) => {
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                }
                setIsLoading(false);
                setHasError(true);
            });
    }

    const handlePaginationButtonClick = function (newPageValue) {
        setIsLoading(true);
        const apiParams = getProductListApiParams();
        apiParams.Page = newPageValue;
        fetchProducts(apiParams);
        updateUrlParams([{ name: "CurrentPage", value: activePageId }])
    }

    const handleSortSelectChange = function (newSortValue) {
        setIsLoading(true);
        const apiParams = getProductListApiParams();
        apiParams.Page = 1;
        apiParams.Sort = newSortValue;
        fetchProducts(apiParams);
        updateUrlParams([{ name: "CurrentPage", value: apiParams.Page }, { name: "sortType", value: apiParams.Sort }])
    }

    const handlePageSizeSelectChange = function (newPageSizeValue) {
        setIsLoading(true);
        const apiParams = getProductListApiParams();
        apiParams.Page = 1;
        apiParams.PageSize = newPageSizeValue;
        fetchProducts(apiParams);
        updateUrlParams([{ name: "CurrentPage", value: apiParams.Page }, { name: "PageSize", value: apiParams.PageSize }])
    }

    const handleFilterChange = function (filterEles) {
        setIsLoading(true);

        //Get all selected filter options into a single array
        filterEles = document.querySelectorAll("[name^='filter']");
        const selectedFilters = [...filterEles].filter(filterCheck => filterCheck.checked)
            .map(filterCheck => JSON.parse(filterCheck.value));

        //Make API Call
        const apiParams = getProductListApiParams();
        apiParams.Page = 1;
        apiParams.AttributeFilters = selectedFilters.map(filterObj => filterObj.id);
        fetchProducts(apiParams);

        //Update query string
        const url = new URL(window.location);
        url.searchParams.delete("filter");
        selectedFilters.map(filterObj => url.searchParams.append("filter", `${filterObj.id}-filtertext-${filterObj.text}`))
        url.searchParams.set("CurrentPage", apiParams.Page);
        window.history.pushState({}, "", url.href);
    }
    const clearAllFilters = function () {
         setIsLoading(true);
        var filterEles = document.querySelectorAll("[name^='filter']");
         [...filterEles].filter(filterCheck => filterCheck.checked).forEach( filterEle=> filterEle.checked=false);
        //Make API Call
        const apiParams = getProductListApiParams();
        apiParams.Page = 1;
        apiParams.AttributeFilters = [];
        fetchProducts(apiParams);
        
        const url = new URL(window.location);
        url.searchParams.delete("filter");
         window.history.pushState({}, "", url.href);
    }
    const handleDashboardCollapse = function (toggleId) {
        setActiveDashboardCollapse(prevToggleId => prevToggleId === toggleId ? null : toggleId);
    }

    useEffect(() => {
        setIsLoading(true);
        fetchProducts();
        setFirstLoad(false);
    }, []);

    return (
        !firstLoad ?
            <div className="product-list__body">
                <div className="product-list">
                    <DashboardToggles
                        filterLabel={filterMobileLabel}
                        clearAllFiltersLabel={clearAllFiltersLabel}
                        sortLabel={sortMobileLabel}
                        viewLabel={viewMobileLabel}
                        itemsPerPage={pageSize}
                        isLoading={isLoading}
                        handleDashboardCollapse={handleDashboardCollapse}
                        onClearAllFilters={clearAllFilters}
                        filters={filters}                    />
                    <DashboardSection
                        filterLabel={filters && filters.length > 0 ? filterLabel : ""}
                        clearAllFiltersLabel={filters && filters.length > 0 && appliedFilters && appliedFilters.length > 0 ? clearAllFiltersLabel : ""}
                        onClearAllFilters={clearAllFilters}
                        isLoading={isLoading}
                        resultCountComponent={<ResultCount
                            resultsCountLabel={productCountLabel}
                            resultsCount={totalItemCount} />}
                        sortSelectComponent={<SortSelect
                            sortLabel={sortLabel}
                            closeSortLabel={sortMobileCloseLabel}
                            sortOptions={sortOptions}
                            sortType={sortType}
                            activeDashboardCollapse={activeDashboardCollapse}
                            handleSortSelectChange={handleSortSelectChange}
                            handleDashboardCollapse={handleDashboardCollapse} />}
                        pageSizeSelectComponent={<PageSizeSelect
                            viewLabel={viewLabel}
                            closeViewLabel={viewMobileCloseLabel}
                            pageSize={pageSize}
                            pageSizeOptions={pageSizeOptions}
                            activeDashboardCollapse={activeDashboardCollapse}
                            handlePageSizeSelectChange={handlePageSizeSelectChange}
                            handleDashboardCollapse={handleDashboardCollapse} />}
                        paginationComponent={<Pagination
                            paginationClassName="hidden-xs hidden sm"
                            currentPage={activePageId}
                            totalPages={totalPageCount}
                            handlePaginationButtonClick={handlePaginationButtonClick} />} />
                    <ProductListResults
                        closeFilterLabel={filterMobileCloseLabel}
                        isLoading={isLoading}
                        activeDashboardCollapse={activeDashboardCollapse}
                        handleDashboardCollapse={handleDashboardCollapse}
                        filterSectionComponent={<FilterSection
                            filters={filters}
                            appliedFilters={appliedFilters}
                            handleFilterChange={handleFilterChange}/>}
                        productListGridComponent={<ProductListGrid
                            {...props}
                            products={displayResults}
                            isLoading={isLoading} />} />
                    <Pagination paginationClassName="pagination--alt"
                        isLoading={isLoading}
                        currentPage={activePageId}
                        totalPages={totalPageCount}
                        handlePaginationButtonClick={handlePaginationButtonClick} />
                </div>
            </div>
            :
            null
    );
}